import PropTypes from 'prop-types';
import {
  Card,
  CardContent,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import AdminNoDataState from './AdminNoDataState';
import AdminStatusChip from './AdminStatusChip';

export default function AdminDataTable({ title, description, columns, rows, emptyTitle, emptyDescription, onRowClick }) {
  return (
    <Card variant="outlined">
      <CardContent>
        <Stack spacing={2.5}>
          <Stack spacing={0.5}>
            <Typography variant="subtitle1">{title}</Typography>
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          </Stack>
          {rows.length ? (
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell key={column.field}>{column.headerName}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row) => (
                    <TableRow
                      hover
                      key={row.id}
                      onClick={onRowClick ? () => onRowClick(row) : undefined}
                      sx={onRowClick ? { cursor: 'pointer' } : undefined}
                    >
                      {columns.map((column) => (
                        <TableCell key={column.field}>
                          {column.render
                            ? column.render(row)
                            : column.field === 'status'
                              ? <AdminStatusChip status={row[column.field]} />
                              : row[column.field]}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <AdminNoDataState title={emptyTitle} description={emptyDescription} />
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}

AdminDataTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  description: PropTypes.string.isRequired,
  emptyDescription: PropTypes.string.isRequired,
  emptyTitle: PropTypes.string.isRequired,
  onRowClick: PropTypes.func,
  rows: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
};

AdminDataTable.defaultProps = {
  onRowClick: undefined,
  rows: [],
};
